// mui
import { Stack, Typography } from '@mui/material';

// mui icon
import {
    Block as BlockIcon,
    SmartDisplay as SmartDisplayIcon,
    VisibilityOff as VisibilityOffIcon,
} from '@mui/icons-material';

// client-shared
import { storage } from '@goldblack/client-storage';
import { path } from '@goldblack/client-utils';
import { DotLoading } from '@goldblack/client-comps';

import { def } from '@goldblack/shared';

// compact: small regular-weight label for grid tiles (the dialog keeps the larger bold one).
function PostShowMediaOverlay(post, showLabel = false, onClick = null, compact = false) {
    const videoOverlay = () => {
        return (
            <Stack
                key='videoOverlay'
                direction='row'
                justifyContent='center'
                alignItems='center'
                style={{ position: 'absolute', top: '0%', right: '0%', pointerEvents: 'none' }}
                spacing={1}>
                <SmartDisplayIcon sx={{ m: 0, fontSize: '24px', color: 'white' }} />
            </Stack>
        );
    };

    const bottomAlphaOverlay = () => {
        return (
            <Stack
                key='bottomAlphaOverlay'
                direction='row'
                justifyContent='center'
                alignItems='center'
                style={{ position: 'absolute', bottom: '0%', left: '0%', pointerEvents: 'none' }}
                sx={{
                    position: 'absolute',
                    bottom: '0%',
                    left: '0%',
                    background: 'linear-gradient( #00000000, #0000007f)',
                    width: '100%',
                    height: '25%',
                    pointerEvents: 'none',
                }}></Stack>
        );
    };

    // dim=false (PROCESSING): no dark layer — the label sits straight on the skeleton placeholder.
    const statusOverlay = (icon, label, dim = true) => {
        return (
            <Stack
                key='statusOverlay'
                direction='column'
                justifyContent='center'
                alignItems='center'
                spacing={label ? 2 : 0}
                onClick={onClick}
                sx={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: dim ? 'rgba(0,0,0,0.6)' : 'transparent',
                    cursor: onClick ? 'pointer' : 'default',
                }}>
                {icon}
                {showLabel && !!label && (
                    <Typography
                        sx={{
                            color: dim ? 'white' : 'text.primary',
                            fontSize: compact ? '10px' : '14px',
                            ...(compact && { fontFamily: 'montserrat', textTransform: 'none' }),
                            textAlign: 'center',
                        }}>
                        {label}
                    </Typography>
                )}
            </Stack>
        );
    };

    const showOverlay = (post) => {
        if (post.status === def.PostStatus.BLOCKED)
            return [statusOverlay(<BlockIcon sx={{ fontSize: 22, color: 'white' }} />, 'Blocked Content')];
        if (post.status === def.PostStatus.CENSORED)
            return [statusOverlay(<VisibilityOffIcon sx={{ fontSize: 22, color: 'white' }} />, 'Sensitive Content')];
        if (post.status === def.PostStatus.PROCESSING) {
            // The dots are for the owner only, and only once the post is saved (a just-picked local
            // post has no userId yet); everyone else sees just the slot border drawn by the media.
            const self = storage.transience.getValue('user');
            const isOwn = Boolean(self?._id && post.userId) && String(self._id) === String(post.userId);
            return isOwn ? [statusOverlay(<DotLoading size={compact ? 5 : 8} />, '', false)] : [];
        }
        return [path.getContentType(post.image).startsWith('video') ? videoOverlay(post) : null, bottomAlphaOverlay()];
    };

    return showOverlay(post);
}

export { PostShowMediaOverlay };
